import { render, staticRenderFns } from "./ChangeUser.vue?vue&type=template&id=1899bd16&scoped=true&"
import script from "./ChangeUser.vue?vue&type=script&lang=js&"
export * from "./ChangeUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1899bd16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1899bd16')) {
      api.createRecord('1899bd16', component.options)
    } else {
      api.reload('1899bd16', component.options)
    }
    module.hot.accept("./ChangeUser.vue?vue&type=template&id=1899bd16&scoped=true&", function () {
      api.rerender('1899bd16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/AdminPage/PageUsers/ChangeUser.vue"
export default component.exports